import 'core-js/es6/promise';

import React, { Fragment } from 'react';
import ReactDOM, { render } from "react-dom";
import axios from 'axios';

import Layout from '../propositionWarningMessageLayout';
//<img class="propositionWarningMessage" src="/images/loading.gif" />
let roots = [].slice.call(document.getElementsByClassName("propositionWarningMessage"));
console.log(roots);

(async () => {
    if (roots.length > 0) {
        await delay(1000);
        let productNumbers = roots.map(x => x.getAttribute('productnumber'));
        await axios.post("/api/PropositionWarning/messages", { productNumbers })
            .then(response => response.data)
            .then(messages => {
                for (let i = 0; i < roots.length; i++) {
                    let element = roots[i];
                    let message = `${messages[element.getAttribute('productnumber')]}`;
                    doRender(element)(message);
                }
            })
            .catch(e => { });
    }
})();

let doRender = (element) => (message) => render(message ? <Layout message={message} /> : <></>, element)
function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}